import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const pageAnim = (() => {
  const FancyboxInit = () => {
    Fancybox.bind('[data-fancybox]', {
      // Carousel: {
      //   AutoPlay: true,
      //   Gap: 10,
      // },
    });
  };

  const fixAppForm = () => {
    if(localStorage.getItem('formIsClosed') === null) {
      localStorage.setItem('formIsClosed', 'false');
    }
    const fixAppFormOpenSubBtn = document.querySelectorAll('.fix-app-form-open-sub-btn');
    const fixAppFormBtn = document.querySelector('.fix-app-form-btn');
    const fixAppForm = document.querySelector('.fix-app-form');
    const fixAppFormClose = document.querySelector('.fix-app-form-close');
    const fixAppFormBg = document.querySelector('.fix-app-form-bg');
    const fixAppBg = document.querySelector('.fix-app-form-bg');

    if(localStorage.getItem('formIsClosed') === 'true' && window.location.pathname !== '/') {
      fixAppForm.classList.remove('active', 'desktop-active');
      fixAppFormBtn.classList.remove('active');
      fixAppFormBg.classList.remove('active');
    } else if(window.location.pathname == '/' && window.innerWidth > 768) {
      fixAppForm.classList.add('desktop-active');
    }
    
    fixAppFormBtn.addEventListener('click', () => {
      fixAppFormBtn.classList.add('active');
      fixAppForm.classList.add('active');
      if(window.innerWidth <= 768){
        fixAppBg.classList.add('active');
      } else{
        fixAppForm.classList.add('desktop-active');
      }
    });
    fixAppFormOpenSubBtn.forEach(btn => {
      btn.addEventListener('click', () => {
        fixAppFormBtn.classList.add('active');
        fixAppForm.classList.add('active');
        fixAppBg.classList.add('active');
        if(window.innerWidth > 768){
          fixAppForm.classList.add('desktop-active');
        }
      });
    });
    fixAppFormClose.addEventListener('click', () => {
      localStorage.setItem('formIsClosed', 'true');
      fixAppForm.classList.remove('active', 'desktop-active');
      fixAppFormBtn.classList.remove('active');
      fixAppFormBg.classList.remove('active');
    });
    fixAppFormBg.addEventListener('click', () => {
      fixAppForm.classList.remove('active');
      fixAppFormBtn.classList.remove('active');
      fixAppFormBg.classList.remove('active');
    });
  };

  const recaptcha = () => {
    const recaptchaBox = document.querySelector('.recaptcha-box');
    const recaptchaEl = recaptchaBox.querySelector('.g-recaptcha');
    var reCaptchaWidth = 304;
    const reCaptchaHeight = 78;
    var containerWidth = recaptchaEl.parentElement.offsetWidth;
    if(reCaptchaWidth > containerWidth) {
      var captchaScale = containerWidth / reCaptchaWidth;
      recaptchaEl.style.transform = `scale(${captchaScale})`;
      const newHeight = reCaptchaHeight * captchaScale;
      recaptchaBox.style.height = `${newHeight}px`;
      recaptchaEl.style.height = `${newHeight}px`;
    }
  };

  const applicationReceivedModal = () => {
    const modal = document.getElementById('applicationReceivedModal');
    const modalClose = document.getElementById('modalClose');
    const modalOverlay = modal?.querySelector('.modal-overlay');
    
    if (!modal) return;

    // Function to open modal
    const openModal = () => {
      modal.style.display = 'flex';
      requestAnimationFrame(() => {
        modal.classList.add('active');
      });
      document.body.style.overflow = 'hidden';
    };

    // Function to close modal
    const closeModal = () => {
      modal.classList.remove('active');
      setTimeout(() => {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }, 300);
    };

    // Close modal when clicking close button
    modalClose?.addEventListener('click', closeModal);

    // Close modal when clicking overlay
    modalOverlay?.addEventListener('click', closeModal);

    // Close modal with Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeModal();
      }
    });

    // Expose openModal function globally for form submissions
    window.showApplicationReceivedModal = openModal;

    return {
      open: openModal,
      close: closeModal
    };
  }


  const init = () => {
    FancyboxInit();
    fixAppForm();
    recaptcha();
    applicationReceivedModal();
  };

  return {
    init,
  };
})();

export default pageAnim;
